<script>
  import TextArea from 'root/components/molecules/inputs/TextArea.svelte';
  import { createEventDispatcher } from 'svelte';

  export let
    value = '',
    maxLength = 0,
    placeholder = '',
    readonly,
    maxHeight;

  const dispatchEvent = createEventDispatcher();

  function dispatch(e){
    if(!readonly) {
      value = maxLength ? e.detail.substring(0, maxLength) : e.detail;
      dispatchEvent(e.type, value);
    }
  }

</script>

<div class="Component" >
  <div class="TextArea" style="{maxHeight? `max-height: ${maxHeight}; overflow:auto;`: ''}">
    <TextArea bind:value
              {placeholder}
              {readonly}
              on:input="{e => dispatch(e)}"
              on:change="{e => dispatch(e)}"
    />
  </div>
</div>


<style lang="stylus">

  .Component {
    position: relative;
  }

  .TextArea {
    border: 1px solid transparent;
    border-radius: 0;

    :global(.TextAreaInputContainer) {
      font-size: 14px;
      line-height: 16px;
      min-height: 18x;
      font-weight: normal;
      font-family: "Noto Sans", sans-serif;
      color: #263238;
      padding-right: 5px;
    }
  }
</style>

